export const heroBackgrounds = [
  '/artwork/hero/waterfall.webp',
  '/artwork/hero/australia.webp',
  '/artwork/hero/fjords.webp',
  '/artwork/hero/lighthouse-01.webp',
  '/artwork/hero/lighthouse-02.webp',
  '/artwork/hero/mountains-01.webp',
  '/artwork/hero/mountains-02.webp',
  '/artwork/hero/mountains-03.webp',
  '/artwork/hero/northern-lights-01.webp',
  '/artwork/hero/northern-lights-02.webp',
  '/artwork/hero/space-01.webp'
];

export const heroTiming = {
  displayMs: 18000,
  fadeMs: 4000
};
